import axios from "axios";
import {
  appendAuthInterceptor,
  requestWrapper,
} from "../../../../Common/serviceFactory";
import {
  getDaysLeft,
  getProposalData,
  getApplicant,
  getContactRishum,
  GetApplicantAcademicBackground,
  GetApplicantPreviousEmployment,
  getFunding,
  getApplicantProjectTimeSchedule,
  getProposalProjectTimeSchedule,
  getProposalsApplicants,
  getProgramInfoByProgramId,
  getColleagues,
  getResearchAreas,
  getResearchSubAreas,
  getBudgetClauses,
  getBudgetClausesByProposalId,
  getProposalRefereesByProposalId,
  UpdateBioethicalApprovals,
  GetContactByProposalRefereeId,
  updateProposal,
  updateFunding,
  updateProposalRefreeByContact,
  udateProjectSchedule,
  updateApplicantMajorresearchinterest,
  updateApplicantAcademicBackground,
  createApplicantAcademicBackground,
  createProjectSchedule,
  createBudgetClause,
  createApplicantPreviousEmployment,
  createProposalRefreeByContact,
  updateApplicantPreviousEmployment,
  updateBudgetClause,
  updateApplicant,
  DeactivateAcademicBackground,
  DeactivatePreviousEmployment,
  DeactivateProjectTimeSchedule,
  DeactiveBudgetClause,
  DeactiveProposalRefferee,
  getApplicantSubmitStatus,
  createProposalPDF,
} from "./applicantService";

import {
  UploadProposalFile,
  UploasApplicantFile,
  getProposalFiles,
  getApplicantsFiles,
  downloadProposalFiles,
  downloadApplicantFiles,
  downloadRawFile,
  deleteProposalFile,
  deleteApplicantFile,
} from "./filesService";
import {
  getAllInstitutions,
  getAllCountries,
  GetBudgetCodes,
  GetContactTitles,
} from "./publicService";

const axiosCMSinstance = axios.create({
  baseURL: `${process.env.REACT_APP_APPLICANTS_CMS_REQUEST_BASE_URL}`,
});
appendAuthInterceptor(axiosCMSinstance);

const service = {
  async addApplicant(proposalId, data) {
    return await requestWrapper(
      axiosCMSinstance.post(`applicants/addApplicant/${proposalId}`, data)
    );
  },
  createProposalPDF,
  getDaysLeft,
  getApplicantSubmitStatus,
  getProposalData,
  getApplicant,
  getContactRishum,
  GetApplicantAcademicBackground,
  GetApplicantPreviousEmployment,
  getFunding,
  getApplicantProjectTimeSchedule,
  getProposalProjectTimeSchedule,
  getProposalsApplicants,
  getColleagues,
  getResearchAreas,
  getResearchSubAreas,
  getBudgetClauses,
  getBudgetClausesByProposalId,
  getProposalRefereesByProposalId,
  GetContactByProposalRefereeId,
  updateProposal,
  updateFunding,
  updateProposalRefreeByContact,
  udateProjectSchedule,
  updateApplicantMajorresearchinterest,
  updateApplicantAcademicBackground,
  createApplicantAcademicBackground,
  createProjectSchedule,
  createBudgetClause,
  createApplicantPreviousEmployment,
  createProposalRefreeByContact,
  updateApplicantPreviousEmployment,
  updateBudgetClause,
  updateApplicant,
  DeactivateAcademicBackground,
  DeactivatePreviousEmployment,
  DeactivateProjectTimeSchedule,
  DeactiveBudgetClause,
  DeactiveProposalRefferee,
  getAllInstitutions,
  getAllCountries,
  GetContactTitles,
  GetBudgetCodes,
  UploadProposalFile,
  UploasApplicantFile,
  getProposalFiles,
  getProgramInfoByProgramId,
  getApplicantsFiles,
  downloadProposalFiles,
  downloadApplicantFiles,
  downloadRawFile,
  deleteProposalFile,
  deleteApplicantFile,
  UpdateBioethicalApprovals,
};
export default service;
